import { Button, Space, Typography, notification } from 'antd';
import { noop } from 'lodash';
import React from 'react';
type NotificationType = 'success' | 'info' | 'warning' | 'error';

const ToastContext = React.createContext<{
  success: (title: string, subtitle: string, button?: { label: string; onClick: () => void }) => void;
  error: (title: string, subtitle: string, button?: { label: string; onClick: () => void }) => void;
}>({
  success: noop,
  error: noop,
});

export const ToastContextProvider = (props) => {
  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (
    type: NotificationType,
    title: string,
    description: string,
    button?: { label: string; onClick: () => void }
  ) => {
    api[type]({
      message: title,
      duration: 5,
      description: (
        <Space direction="vertical">
          <Typography.Text>{description}</Typography.Text>
          {button && (
            <Button type="primary" onClick={button?.onClick}>
              {button?.label}
            </Button>
          )}
        </Space>
      ),
    });
  };

  const successToast = (title: string, subtitle: string, button?: { label: string; onClick: () => void }) => {
    openNotificationWithIcon('success', title, subtitle, button);
  };

  const errorToast = (title: string, subtitle: string) => {
    openNotificationWithIcon('error', title, subtitle);
  };

  return (
    <ToastContext.Provider
      value={{
        success: successToast,
        error: errorToast,
      }}
    >
      {contextHolder}
      {props.children}
    </ToastContext.Provider>
  );
};

export default ToastContext;
